import { NgModule } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { OrdersRoutingModule } from './orders-routing.module'
import { SharedModule } from '../shared/shared.module'
import { FacetsModule } from '../facets/facets.module'
import { reducers } from './reducers'

import { OrderService } from './services/orders.service'

import { OrderPageContainer } from './containers/order-page-container/order-page-container'

import { OrderlineTableComponent } from './components/orderline-table'
import { OrderlineComponent } from './components/orderline'
import { OrderPageComponent } from './components/order-page/order-page.component'

import { MetaEffects } from './effects/meta'
import { FacetEffects } from './effects/facet'
import { OrderEffects } from './effects/order'

@NgModule({
  imports: [
    SharedModule,
    FacetsModule
  ],
  providers: [
    OrderService
  ],
  declarations: [
    OrderPageContainer,
    OrderPageComponent,
    OrderlineTableComponent,
    OrderlineComponent
  ]
})
export class OrdersModule {
  public static forRoot() {
    return {
      ngModule: RootOrdersModule,
      providers: [
        HttpClient
      ]
    }
  }
}

@NgModule({
  imports: [
    OrdersModule,
    OrdersRoutingModule,
    StoreModule.forFeature('orders', reducers),
    EffectsModule.forFeature([
      MetaEffects,
      FacetEffects,
      OrderEffects
    ])
  ]
})
export class RootOrdersModule { }
